import apiClient from '../config/axios';
import ENDPOINTS from '../constants/endpoints';

export const certificatService = {
  // Get all certificats with filters
  getCertificats: async (limit = 10, page = 1, filters = {}) => {
    try {
      // Build query params from filters
      const params = {};
      if (filters.searchTerms) params.searchTerms = filters.searchTerms;
      if (filters.clientId) params.clientId = filters.clientId;

      const response = await apiClient.get(
        `${ENDPOINTS.CERTIFICATS}/${limit}/${page}`,
        { params }
      );
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get certificats error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la récupération des certificats',
        error: error.response?.data,
      };
    }
  },

  // Create new certificat - FIXED to handle FormData properly
  createCertificat: async (formData) => {
    try {
      // Make sure we're sending FormData correctly
      const response = await apiClient.post(ENDPOINTS.CERTIFICATS, formData, {
        headers: {
          // Remove Content-Type to let browser set it with boundary for multipart/form-data
          'Content-Type': undefined,
        },
      });
      
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Create certificate error:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de la création du certificat',
        error: error.response?.data,
      };
    }
  },

  // Update certificat
  updateCertificat: async (id, formData) => {
    try {
      // Append id to FormData if not present
      if (formData instanceof FormData && !formData.has('Id')) {
        formData.append('Id', id);
      }
      const response = await apiClient.put(
        `${ENDPOINTS.CERTIFICATS}`,
        formData,
        {
          headers: {
            'Content-Type': undefined, // Let browser set it
          },
        }
      );
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Update certificate error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la mise à jour du certificat',
        error: error.response?.data,
      };
    }
  },

  // Delete certificat
  deleteCertificat: async (id) => {
    try {
      const response = await apiClient.delete(`${ENDPOINTS.CERTIFICATS}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Delete certificate error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression du certificat',
        error: error.response?.data,
      };
    }
  },

  // Get certificat by ID
  getCertificatById: async (id) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.CERTIFICATS}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get certificate by ID error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la récupération du certificat',
        error: error.response?.data,
      };
    }
  },

  // Download certificat - NEW METHOD
  downloadCertificat: async (certifId) => {
    try {
      const response = await apiClient.get(
        `${ENDPOINTS.CERTIFICATS}/DownloadCertificat/${certifId}`,
        {
          responseType: 'blob', // Important for file download
        }
      );
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Try to get filename from response headers
      const contentDisposition = response.headers['content-disposition'];
      let filename = `certificat_${certifId}.pdf`;
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return {
        success: true,
        message: 'Certificat téléchargé avec succès',
      };
    } catch (error) {
      console.error('Download certificate error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du téléchargement du certificat',
        error: error.response?.data,
      };
    }
  },
};

export default certificatService;